import {Component, OnInit} from '@angular/core';
import {PaymentEmailRemindersService} from '../../../../services/payment-email-reminders.service';
import {ActivatedRoute} from '@angular/router';
import {EmailReminder} from '../../../../dto/email-reminder';
import {MatTableDataSource} from '@angular/material/table';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-reminder-distribution',
  templateUrl: './reminder-distribution.component.html',
  styleUrls: ['./reminder-distribution.component.scss']
})
export class ReminderDistributionComponent implements OnInit {

  remindersDataSource: MatTableDataSource<EmailReminder>;

  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private paymentEmailRemindersService: PaymentEmailRemindersService
  ) {
  }

  remindersColumns = [
    {
      columnDef: 'date',
      header: 'Date',
      cell: (row: EmailReminder) => `${this.datePipe.transform(row.date, 'dd.MM.yyyy HH:mm')}`
    },
    {
      columnDef: 'email', header: 'Email', cell: (row: EmailReminder) => {

        if (row.invoice.email != null) {
          return row.invoice.email;
        }

        if (row.invoice.firstOrder != null) {
          return row.invoice.firstOrder.email;
        }

        return '';

      }
    },
    {columnDef: 'reminder_order', header: 'Reminder Type', cell: (row: EmailReminder) => `${row.type.order}`},
    {columnDef: 'invoice', header: 'Invoice', cell: (row: EmailReminder) => `${row.invoice.code}`},
    {
      columnDef: 'order_ref',
      header: 'External ref',
      cell: (row: EmailReminder) => {
        if( row.invoice.firstOrder != null ) {
return row.invoice.firstOrder.externalRef;
}

        return '';
      }
    },
  ];

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.paymentEmailRemindersService.getRemindersByDistribution(id).subscribe(result => {
      this.remindersDataSource = new MatTableDataSource(result.data);
    });
  }

}
